<template>
  <fieldset class="type-fieldset">
    <legend>Type</legend>
    <div class="row">
      <div class="col-md-2"></div>
      <div class="col-md-3">
        <label class="radio-style"
          >Number of Views
          <input type="checkbox" name="radio" />
          <span class="checkmark"></span>
        </label>
      </div>
      <div class="col-md-7">
        <input type="number" id="view-counter" name="view" placeholder="0"  class="text-end"/>
        <label id="unix-style">Views</label>
      </div>

      <div class="col-md-2"></div>
      <div class="col-md-3">
        <label class="radio-style"
          >Duration
          <input type="checkbox" name="radio" />
          <span class="checkmark"></span>
        </label>
      </div>
      <div class="col-md-7">
        <input type="number" id="view-counter" name="day" placeholder="0"  class="text-end"/>
        <label id="unix-style">Days</label>
      </div>

      <div class="col-md-2"></div>
      <div class="col-md-3">
        <label class="radio-style"
          >Fixed Budget
          <input type="checkbox" name="radio" />
          <span class="checkmark"></span>
        </label>
      </div>
      <div class="col-md-7">
        
        <input type="number" id="view-counter" name="budget" placeholder="0.00"  class="text-end"/>
        <label id="unix-style">USD</label>
      </div>
    </div>
  </fieldset>
</template>

<script>
export default {
  methods: {
    NumbersOnly(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$main-color: #93014a;

.type-fieldset {
  .radio-style {
    position: relative;
    padding-left: 20%;
    padding-right: 4%;
    cursor: pointer;
    font-size: 18px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  /* Hide the browser's default radio button */
  .radio-style input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
  }

  /* Create a custom radio button */
  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 25px;
    width: 25px;
    background-color: #eee;
    border-radius: 50%;
  }

  /* On mouse-over, add a grey background color */
  .radio-style:hover input ~ .checkmark {
    background-color: #ccc;
  }

  /* When the radio button is checked, add a blue background */
  .radio-style input:checked ~ .checkmark {
    background-color: white;
  }

  /* Create the indicator (the dot/circle - hidden when not checked) */
  .checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }

  /* Show the indicator (dot/circle) when checked */
  .radio-style input:checked ~ .checkmark:after {
    display: block;
  }

  /* Style the indicator (dot/circle) */
  .radio-style .checkmark:after {
    top: 1px;
    left: 1px;
    width: 23px;
    height: 23px;
    border-radius: 50%;
    background: $main-color;
  }

  #view-counter {
    background-color: white;
    max-width: 99px;
    padding: 1%;
  }

  #unix-style {
    padding-left: 4%;
    font-size: 18px;
  }
}
</style>